<div class="competitor-articles-accordion-title">
  <div class="competitor-articles-accordion-title-value">
    @if (competitorArticleData().article) {
      {{ competitorArticleData().article }} - {{ competitorArticleData().articleName }}
    } @else {
      Новый
    }
  </div>
  <div class="competitor-articles-accordion-title-content">
    @if (competitorArticleData().marketplaceType) {
      <mat-icon [class]="marketplaceIcon()">
        {{ marketplaceIcon() }}
      </mat-icon>
    }
    @if (!!competitorArticleData().id && isEditModeActive()) {
      <button
        mat-mini-fab
        class="competitor-articles-accordion-title-btn"
        (click)="handleDeleteData($event)"
      >
        <mat-icon class="title-btn-icon">delete</mat-icon>
      </button>
    }
  </div>
</div>
